import { msg } from '../messages'
import * as Util from '../util'
import { numeroDoTelefoneTemTodosDigitosIguais } from './telefone'

const TELEFONE = '^\\d{2}9\\d{8}$'

export function celular(value: string) {
  if (!Util.isEmpty(value) && (numeroDoTelefoneTemTodosDigitosIguais(value) || !new RegExp(TELEFONE).test(value))) {
    return msg('celularInvalid', value)
  }
}
